import React from 'react';
import { useGetMe } from '../../services/auth/auth';
import ThemeToggle from '../ThemeToggle';
const WelcomeBanner = () => {
  const { data: user } = useGetMe();

  return (
    <div className="bg-gray-100 dark:bg-[#1d2026] px-3 py-4 rounded-lg flex justify-between items-start mb-4">
      <div>
        <h1 className="font-medium text-xl md:text-2xl md:font-semibold text-gray-800 dark:text-white mb-2">
          Welcome back, {user?.firstName || 'Hellocian'}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-[11px] md:text-sm">
         Another day to make a difference — check your inbox and ongoing project chats.
        </p>
      </div>
      <ThemeToggle />
    </div>
  );
};

export default WelcomeBanner;